import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { formatImageCMSData } from "@/components/common/Image"
import CommonImage from "@/components/common/Image"
import SimpleIconButton, { SIMPLE_ICON_BUTTON_ANIMATIONS, SIMPLE_ICON_BUTTON_CLASS_NAME } from "@/components/common/SimpleIconButton"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"

const Wrapper = styled.div`
	width: 100%;
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	border-bottom: none;
	transition: all var(--rgr-duration) var(--ease);
	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
	}

	&.hover {
		background: ${({ theme }) => theme.colors.periwinkle};
	}

	&.last {
		cursor: pointer;
	}
`

const ImageWrapper = styled.div`
	position: relative;
	display: flex;
	aspect-ratio: 3/4;
	padding: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	padding-bottom: unset;

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16)};
	}

	&.last {
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			aspect-ratio: unset;
		}

		height: 100%;
		align-items: center;
		justify-content: center;
	}

	.${SIMPLE_ICON_BUTTON_CLASS_NAME} {
		position: absolute;
		top: 0;
		right: 0;
	}
`

const Image = styled(CommonImage)`
	width: 100%;
	height: 100%;

	&.last {
		width: ${getCssSizeValue(168, BREAKPOINTS.MOBILE)};
		height: auto;
		aspect-ratio: 1;

		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		}

		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			width: ${getCssSizeValue(200)};
		}
	}
`

export default function ImageTile({ data, isLastTile, index, isLastElementHovered, handleHoverElement, handleClickLastElement }) {
	const image = formatImageCMSData(data?.image?.image)
	const className = isLastTile ? "col-desktop-7 col-tablet-8 col-mobile-8" : "col-desktop-4 col-tablet-4 col-mobile-8"
	const isLastClassName = isLastTile ? "last" : ""
	const isHovered = isLastElementHovered && isLastTile ? "hover" : ""

	return (
		<Wrapper
			onClick={handleClickLastElement}
			className={`${className} ${isLastClassName} ${isHovered}`}
			onMouseEnter={() => handleHoverElement(index)}
			onMouseLeave={() => handleHoverElement(-1000)}
		>
			<ImageWrapper className={isLastClassName}>
				{isLastTile && (
					<SimpleIconButton
						bgColor={colors.chilliRed}
						borderColor={colors.chilliRed}
						rotation={135}
						animation={isHovered ? SIMPLE_ICON_BUTTON_ANIMATIONS.ROTATE_45 : ""}
					/>
				)}
				<Image className={isLastClassName} src={image.url} alt={image.alt} />
			</ImageWrapper>
		</Wrapper>
	)
}
